import { ref } from 'vue';
import { defineStore } from 'pinia';
import type { Cookies } from '@/shared/API/Root/models';

export const useCookiesStore = defineStore('cookies', () => {
    const cookie = ref<Cookies | null>(null);

    return {
        cookie,
    };
}, {
    persist: true,
});

export type CookiesStore = ReturnType<typeof useCookiesStore>;
